import { render } from "./Labels.vue?vue&type=template&id=6a99a736&scoped=true"
import script from "./Labels.vue?vue&type=script&setup=true&lang=js"
export * from "./Labels.vue?vue&type=script&setup=true&lang=js"

import "./Labels.vue?vue&type=style&index=0&id=6a99a736&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a99a736"],['__file',"resources/js/components/whatsapp-managment/includes/components/Labels.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6a99a736"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6a99a736', __exports__)) {
    console.log('reload')
    api.reload('6a99a736', __exports__)
  }
  
  module.hot.accept("./Labels.vue?vue&type=template&id=6a99a736&scoped=true", () => {
    console.log('re-render')
    api.rerender('6a99a736', render)
  })

}


export default __exports__